const items = [
  "100% पुलिस Verified स्टाफ",
  "Taski / Diversey इको-फ्रेंडली केमिकल",
  "SLA आधारित गुणवत्ता गारंटी",
  "पूर्ण Public Liability बीमा कवर",
  "हर काम, समय पर और गारंटी के साथ",
];

export const TrustMarquee = () => (
  <div
    data-testid="trust-marquee"
    className="relative border-y border-white/10 py-6 md:py-8 overflow-hidden bg-[#0C1B24]"
  >
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center shrink-0">
          {items.map((item, i) => (
            <span key={i} className="flex items-center shrink-0">
              <span className="font-khand font-semibold text-3xl md:text-5xl text-white/60 whitespace-nowrap px-6">
                {item}
              </span>
              <span className="text-[#00F0FF] text-2xl md:text-4xl px-2">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
